import { gsap } from 'gsap'

// Simple loader that fades the overloadloader in and out

const SELECTOR = '.js-overlay-loader'

const getEls = () => {
	const overlay = document.querySelector(SELECTOR)
	if (!overlay) return null
	return {
		overlay,
	}
}

export const scallopLoader = {
	/**
	 * Ensure the mask covers the screen.
	 * @param {{ animate?: boolean }} [opts] animate:true fades the overlay in (swup `out`);
	 *   animate:false snaps to the covering state (initial load / safety).
	 * @returns {Promise<void>}
	 */
	show({ animate = false } = {}) {
		const els = getEls()
		if (!els) return Promise.resolve()
		const { overlay } = els
		gsap.set(overlay, { display: 'flex' })
		if (!animate) {
			// Snap to the covering state the exit animation starts from.
			gsap.set(overlay, { opacity: 1 })
			return Promise.resolve()
		}
		return new Promise((resolve) => {
			gsap.fromTo(overlay, { opacity: 1, y: '-120%' }, { opacity: 1, y: '0%', duration: 0.5, ease: 'power.in', onComplete: resolve })
		})
	},

	/**
	 * Fade the mask out, then hide it.
	 * @returns {Promise<void>}
	 */
	hide() {
		const els = getEls()
		if (!els) return Promise.resolve()
		const { overlay } = els
		return new Promise((resolve) => {
			gsap.to(overlay, {
				opacity: 1,
				y: '120%',
				duration: 0.5,
				ease: 'power.out',
				onComplete: () => {
					gsap.set(overlay, { display: 'none' })
					resolve()
				},
			})
		})
	},
}
